<script lang="ts">
	//UI
	import { TopBottom, InlineButton } from "@hitit/new_ui";
	//Utils
	//Types
	//Props
	export let createdDate = "";
	export let publishedDate = "";
	export let obsoletedDate = "";
	export let viewCount = 0;
	//Constants
	const additonalDatesType = ["PUBLISHED", "OBSOLETED"];
	//Variables
	let additonalDateOpen = false;
	$: additonalDates = [publishedDate, obsoletedDate];
	//Functions
	//Do
</script>

<div class="container">
	<span class="view-count">
		읽음 {viewCount}
	</span>
	<div class="change-history">
		<InlineButton on:click={() => (additonalDateOpen = !additonalDateOpen)}>
			<div class="button-inner">
				<span class="created">
					{createdDate}
				</span>
				<span class="icon">
					<TopBottom top={additonalDateOpen} />
				</span>
			</div>
		</InlineButton>
		{#if additonalDateOpen}
			<div class="history-container">
				{#each additonalDates as date, index}
					<div class="history">
						<div class="top">
							<span class="icon" class:published={index === 0} />
							<span class="type"> {additonalDatesType[index]}</span>
						</div>
						<div class="date">
							{date ? date : "정보 없음"}
						</div>
					</div>
				{/each}
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 20px;

		.view-count {
			color: #46474b;
		}

		.change-history {
			position: relative;
		}
		.button-inner {
			display: flex;
			align-items: center;
			gap: 5px;
			color: #46474b;
			font-weight: 200;

			.icon {
				display: flex;
				align-items: center;
				width: 15.8px;
				height: 8px;
			}
		}

		.history-container {
			position: absolute;
			top: 30px;
			right: 0;
			background-color: white;
			box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			padding: 0px 10px;

			.history {
				display: flex;
				flex-direction: column;
				gap: 5px;
				padding: 10px 0px;
				word-break: keep-all;
				&:first-child {
					border-bottom: 1px solid #d3d4da;
				}

				.top {
					display: flex;
					align-items: center;
					gap: 10px;
					.type {
						color: #46474b;
						margin-top: -2px;
					}

					.icon {
						width: 15px;
						height: 15px;
						border-radius: 15px;
						background-color: #ffce00;

						&.published {
							background-color: #44e4ae;
						}
					}
				}

				.date {
					font-size: 0.875rem;
					color: #6d6f76;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			gap: 30px;
			font-size: 1.25rem;
			.view-count {
				margin-top: -2px;
			}
			.button-inner {
				.icon {
					width: 19.8px;
					height: 10px;
				}
			}

			.history-container {
				padding: 10px 30px;

				.history {
					gap: 10px;

					.top {
						gap: 7px;
						.icon {
							width: 20px;
							height: 20px;
							border-radius: 20px;
						}
					}

					.date {
						font-size: 1rem;
					}
				}
			}
		}
	}
</style>
